// extracted by mini-css-extract-plugin
export default {"section":"FavContacts_section__QkM6H"};